var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as Styles from './styles.css';
import Table from 'antd/lib/table';
import React, { useEffect } from 'react';
import { Resizable } from 'react-resizable';
import { COLORS } from 'renderer/styles';
import Input from 'antd/lib/input/Input';
import { TableColumnSetter, useTableColumnGetter, Icon, ModalWithClick, HEADER_WITH_SUBHEADER, typographyByName, TextComponent } from 'renderer/components';
import Menu from 'antd/lib/menu';
import { isArray, Lodash, useWindowSize, isEqual } from 'renderer/utils';
import styled, { css } from 'styled-components';
import { isNumber } from 'common-utils/lodash';
import { useMeasure } from 'react-use';
var MIN_COLUMN_WIDTH = 35;
var MAX_COLUMN_WIDTH = 500;
var MAX_COLUMN_WIDTH_IN_MOBILE = 300;
var DEFAULT_COLUMN_WIDTH = 100;
export var TableComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var isPC = useWindowSize().isPC;
    var _h = useMeasure(), ref = _h[0], width = _h[1].width;
    var deaultLocalColumns = (_b = (_a = props.columns) === null || _a === void 0 ? void 0 : _a.filter(Boolean)) === null || _b === void 0 ? void 0 : _b.map(function (column) { return (__assign(__assign({}, column), { columnKey: column.key, isActive: true })); });
    var _j = useTableColumnGetter(props.id, deaultLocalColumns), localColumnSettings = _j[0], setLocalColumnSettings = _j[1];
    /**
     * 순서 / 보이기,감추기 / 넓이 요소만 가져와야한다.
     */
    var getTargetColumns = React.useMemo(function () {
        var _a;
        var localColumns = (localColumnSettings === null || localColumnSettings === void 0 ? void 0 : localColumnSettings.filter(Boolean)) || [];
        var originalColumns = ((_a = props.columns) === null || _a === void 0 ? void 0 : _a.filter(Boolean)) || [];
        var columnWidth = 0;
        var resultColumns = props.availableColumnSettings
            ? localColumns
                .map(function (localColumn) {
                var originalColumn = originalColumns.find(function (column) { return column.key === localColumn.columnKey; });
                if (!originalColumn || !localColumn.isActive) {
                    return null;
                }
                else {
                    var width_1 = localColumn.width || originalColumn.width || DEFAULT_COLUMN_WIDTH;
                    columnWidth = columnWidth + width_1;
                    return __assign(__assign({}, originalColumn), { width: width_1 });
                }
            })
                .filter(Boolean)
                .concat(originalColumns
                .map(function (originalColumn) {
                var savedColumn = localColumns.find(function (item) { return item.columnKey === originalColumn.key; });
                if (savedColumn) {
                    return null;
                }
                else {
                    var width_2 = originalColumn.width || DEFAULT_COLUMN_WIDTH;
                    columnWidth = columnWidth + width_2;
                    return __assign(__assign({}, originalColumn), { width: width_2 });
                }
            })
                .filter(Boolean))
            : originalColumns
                .map(function (originalColumn) {
                var savedColumn = localColumns.find(function (item) { return item.columnKey === originalColumn.key; });
                var width = (savedColumn === null || savedColumn === void 0 ? void 0 : savedColumn.width) || originalColumn.width || DEFAULT_COLUMN_WIDTH;
                columnWidth = columnWidth + width;
                return __assign(__assign({}, originalColumn), { width: width });
            })
                .filter(Boolean);
        var shouldAddWidth = (width - columnWidth) / resultColumns.length;
        return shouldAddWidth > 0 && isEqual(JSON.stringify(deaultLocalColumns), JSON.stringify(localColumns))
            ? resultColumns.map(function (column) { return (__assign(__assign({}, column), { width: column.width + shouldAddWidth })); })
            : resultColumns;
    }, [localColumnSettings, props.columns, width]);
    var targetColumns = getTargetColumns;
    var _k = React.useState(targetColumns), columns = _k[0], setColumns = _k[1];
    React.useEffect(function () {
        if (!isEqual(columns, targetColumns)) {
            setColumns(targetColumns);
        }
    }, [targetColumns]);
    var handleResize = function (index) {
        return function (e, _a) {
            var size = _a.size;
            var nextColumns = __spreadArray([], columns, true);
            var newColumn = __assign(__assign({}, nextColumns[index]), { width: size.width > MIN_COLUMN_WIDTH
                    ? MAX_COLUMN_WIDTH < size.width
                        ? isPC
                            ? MAX_COLUMN_WIDTH
                            : MAX_COLUMN_WIDTH_IN_MOBILE
                        : size.width
                    : MIN_COLUMN_WIDTH });
            nextColumns[index] = newColumn;
            if (!!props.resizable) {
                setLocalColumnSettings((localColumnSettings || deaultLocalColumns).map(function (item) {
                    if (item.columnKey === newColumn.key) {
                        return __assign(__assign({}, item), { width: newColumn.width });
                    }
                    else {
                        return item;
                    }
                }));
            }
            setColumns(nextColumns);
        };
    };
    var newColumns = function () {
        return (columns || []).filter(Boolean).map(function (col, index) {
            var newCol = col;
            if (col.onSave && col.editable) {
                newCol = __assign(__assign({}, newCol), { onCell: function (record) {
                        return ({
                            record: record,
                            editable: !!col.editable,
                            dataIndex: col.dataIndex,
                            title: col.title,
                            onChange: col.onChange,
                            onSave: col.onSave
                        });
                    } });
            }
            if (!!props.resizable) {
                newCol = __assign(__assign({}, newCol), { onHeaderCell: function (column) {
                        return {
                            width: column.width || DEFAULT_COLUMN_WIDTH,
                            onResize: handleResize(index)
                        };
                    } });
            }
            // col.ellipsis default를 true로 변경
            col.ellipsis = typeof col.ellipsis === 'boolean' ? col.ellipsis : true;
            // if (col.ellipsis) {
            //   const render = newCol.render;
            //   newCol = {
            //     ...newCol,
            //     render: render
            //       ? (...args) => {
            //           let child: any = render(...args);
            //           return (
            //             <Tooltip
            //               placement="topLeft"
            //               title={child}
            //               color={COLORS.white}
            //               overlayInnerStyle={{ color: '#000000' }}
            //             >
            //               {child}
            //             </Tooltip>
            //           );
            //         }
            //       : (child) => {
            //           if (child?.children && child?.props) {
            //             child = React.cloneElement(child.children, child.props);
            //           }
            //           return (
            //             <Tooltip
            //               placement="topLeft"
            //               title={child}
            //               color={COLORS.white}
            //               overlayInnerStyle={{ color: '#000000' }}
            //             >
            //               {child}
            //             </Tooltip>
            //           );
            //         }
            //   };
            // }
            return __assign(__assign({}, newCol), { defaultSortOrder: newCol.defaultSortOrder
                    ? newCol.defaultSortOrder === 'asc'
                        ? 'ascend'
                        : 'descend'
                    : null });
        });
    };
    var handleColumnSettingChange = function (data) {
        setColumns(data
            .map(function (column) {
            return column.isActive && props.columns.filter(Boolean).find(function (target) { return target.key === column.columnKey; });
        })
            .filter(Boolean));
        setLocalColumnSettings(data.map(function (item) {
            var target = (localColumnSettings || deaultLocalColumns).find(function (target) { return target.columnKey === item.columnKey; });
            if (target) {
                return __assign(__assign({}, target), { isActive: item.isActive });
            }
            else {
                return item;
            }
        }));
    };
    var handleRowClick = function (ev, record, rowIndex) {
        setModalStyle({
            top: ev.clientY,
            left: ev.clientX,
            height: 200,
            data: record
        });
    };
    var _l = React.useState(undefined), modalStyle = _l[0], setModalStyle = _l[1];
    var isClickableRow = !!props.onRow || !!props.actions;
    var columnWidth = sumColumnWidth(newColumns());
    var tableWidth = columnWidth + (((_c = props.resizable) === null || _c === void 0 ? void 0 : _c.additionalColumnWidth) || 0);
    var xScroll = ((_d = props.scroll) === null || _d === void 0 ? void 0 : _d.x) && tableWidth > ((_e = props.scroll) === null || _e === void 0 ? void 0 : _e.x) ? (_f = props.scroll) === null || _f === void 0 ? void 0 : _f.x : null;
    var columnsForTable = newColumns();
    // 과거 로컬스토리지(localStorage)에 저장된 컬럼 설정 중
    // key 값이 dataIndex와 다르게 저장되어 있는 경우를 방지하기 위한 정리 작업
    useEffect(function () {
        if (localColumnSettings === null || localColumnSettings === void 0 ? void 0 : localColumnSettings.some(function (item) { return item['key'] !== item['dataIndex']; })) {
            setLocalColumnSettings(localColumnSettings.map(function (item) {
                if (item['key'] !== item['dataIndex']) {
                    return __assign(__assign({}, item), { key: item['dataIndex'] });
                }
                else {
                    return item;
                }
            }));
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        props.availableColumnSettings && (React.createElement(TableColumnSetter, { visible: props.columnSetterVisible, onCloseSetter: props.onCloseSetter, handleChange: handleColumnSettingChange, tableId: props.id, defaultColumns: props.columns })),
        modalStyle && props.actions && (React.createElement(RowModal, { onClose: function () { return setModalStyle(undefined); }, modalStyle: modalStyle, actions: props.actions })),
        React.createElement(TableWrapper, { ref: ref },
            React.createElement(StyledTable, __assign({ bordered: false, rowKey: "id" }, props, { onRow: function (record, rowIndex) {
                    return props.onRow
                        ? __assign({}, props.onRow(record, rowIndex)) : {
                        onClick: function (event) {
                            if (props.actions) {
                                handleRowClick(event, record, rowIndex);
                            }
                        }
                    };
                }, scroll: {
                    y: (_g = props.scroll) === null || _g === void 0 ? void 0 : _g.y,
                    x: xScroll
                }, style: __assign(__assign({ cursor: isClickableRow ? 'pointer' : 'auto' }, props.style), { width: props.isFull ? '100%' : "".concat(tableWidth, "px") }), columns: columnsForTable, pagination: (props.pagination ? __assign(__assign({}, props.pagination), { position: ['bottomCenter'] }) : false), components: __assign({ header: {
                        cell: ResizableTitle
                    } }, props.components), onChange: function (pagination, filters, sorter, extra) {
                    if (props.onChange) {
                        props.onChange(pagination, filters, (isArray(sorter)
                            ? sorter.map(function (item) { return (__assign(__assign({}, sorter), { order: !item.order ? undefined : item.order === 'ascend' ? 'asc' : 'desc' })); })
                            : __assign(__assign({}, sorter), { order: !sorter.order ? undefined : sorter.order === 'ascend' ? 'asc' : 'desc' })), extra);
                    }
                } })))));
};
var TableWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
export var RowModal = function (props) {
    var MODAL_WIDTH = 200;
    var modalStyle = props.modalStyle, actions = props.actions;
    return (modalStyle && (React.createElement(ModalWithClick, { modalStyle: __assign(__assign({}, modalStyle), { modalWidth: MODAL_WIDTH, topOffset: actions.length * 32 }), onClose: props.onClose },
        React.createElement(StyledMenu, { mode: "vertical", onClick: function (ev) {
                var _a;
                var func = (_a = actions[ev.key]) === null || _a === void 0 ? void 0 : _a.onClick;
                if (func) {
                    func(modalStyle.data);
                    props.onClose();
                }
            } }, props.actions.map(function (action, index) {
            var disabled = action.disabled || (action.isDisabled && action.isDisabled(modalStyle.data));
            var color = disabled ? COLORS.gray4 : action.color || COLORS.gray1;
            return (React.createElement(StyledMenuItem, { disabled: disabled, key: index, icon: action.icon ? (typeof action.icon === 'string' ? (React.createElement(Icon, { size: 16, name: action.icon, color: color })) : (action.icon)) : undefined },
                React.createElement(TextComponent, { children: action.title, color: color })));
        })))));
};
var StyledMenu = styled(Menu)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & li {\n    height: 32px !important;\n    align-items: center;\n    display: flex;\n  }\n"], ["\n  & li {\n    height: 32px !important;\n    align-items: center;\n    display: flex;\n  }\n"])));
var StyledMenuItem = styled(Menu.Item)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex !important;\n  // height: 32px;\n  ", "\n\n  & > img {\n    opacity: ", ";\n  }\n"], ["\n  display: flex !important;\n  // height: 32px;\n  ", "\n\n  & > img {\n    opacity: ", ";\n  }\n"])), function (props) {
    return !props.disabled &&
        "\n      &:hover {\n        background-color: ".concat(COLORS.gray7, ";\n        color: ").concat(COLORS.gray1, " !important;\n      }\n  ");
}, function (props) { return (props.disabled ? 0.4 : 1); });
var ResizableTitle = function (props) {
    var isPC = useWindowSize().isPC;
    var onResize = props.onResize, width = props.width, restProps = __rest(props, ["onResize", "width"]);
    if (!width) {
        return React.createElement("th", __assign({}, restProps));
    }
    return (React.createElement(Resizable, { width: width, height: 0, handle: React.createElement(Handler, { "$isPC": isPC, className: Styles.resizeHandler, onClick: function (e) {
                e.stopPropagation();
            } }), onResize: onResize, draggableOpts: { enableUserSelectHack: false } },
        React.createElement("th", __assign({}, restProps))));
};
var Handler = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  ", "\n  bottom: 0;\n  z-index: 1;\n  width: ", ";\n  height: 100%;\n  cursor: col-resize;\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  position: absolute;\n  ", "\n  bottom: 0;\n  z-index: 1;\n  width: ", ";\n  height: 100%;\n  cursor: col-resize;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) { return (props.$isPC ? 'right: -5px;' : 'left: 0px;'); }, function (props) { return (props.$isPC ? '10px' : 'calc(100% - 10px)'); }, COLORS.primary1);
var EditableCell = function (_a) {
    var title = _a.title, editable = _a.editable, children = _a.children, dataIndex = _a.dataIndex, record = _a.record, onSave = _a.onSave, restProps = __rest(_a, ["title", "editable", "children", "dataIndex", "record", "onSave"]);
    var _b = React.useState(false), editing = _b[0], setEditing = _b[1];
    var defaultValue = Lodash.get(record, dataIndex);
    var _c = React.useState(defaultValue), value = _c[0], setValue = _c[1];
    var inputRef = React.useRef();
    React.useEffect(function () {
        var _a;
        if (editing) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [editing]);
    React.useEffect(function () {
        if (defaultValue !== value) {
            setValue(defaultValue);
        }
    }, [defaultValue]);
    var toggleEdit = function () {
        setEditing(!editing);
    };
    var save = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!value) {
                return [2 /*return*/, setValue(defaultValue)];
            }
            try {
                toggleEdit();
                onSave(Lodash.set(record, dataIndex, value));
            }
            catch (errInfo) {
                console.log('Save failed:', errInfo);
            }
            return [2 /*return*/];
        });
    }); };
    var handleChange = function (event) {
        setValue(event.target.value);
    };
    var childNode = children;
    if (editable) {
        childNode = editing ? (React.createElement(Input, { ref: inputRef, onPressEnter: save, onBlur: save, value: value, onChange: handleChange })) : (React.createElement("div", { className: "editable-cell-value-wrap", style: { paddingRight: 24 }, onClick: toggleEdit },
            children,
            " ",
            React.createElement(Icon, { name: "edit" })));
    }
    return React.createElement("td", __assign({}, restProps), childNode);
};
export var StyledTable = styled(Table)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */\n  .ant-table-cell {\n    // padding: 6px;\n    ", "} \n    color: ", ";\n  }\n  .ant-table-thead > tr > th {\n    padding: 6px;\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    ", "} \n  }\n  \n  .ant-table-thead > tr > th {\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  .ant-table-tbody > tr > td {\n    padding: 6px;\n    color: ", ";\n  }\n  & .ant-table-selection-column {\n    border-right: 0px !important;\n  }\n"], ["\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */\n  .ant-table-cell {\n    // padding: 6px;\n    ", "} \n    color: ", ";\n  }\n  .ant-table-thead > tr > th {\n    padding: 6px;\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    ", "} \n  }\n  \n  .ant-table-thead > tr > th {\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  .ant-table-tbody > tr > td {\n    padding: 6px;\n    color: ", ";\n  }\n  & .ant-table-selection-column {\n    border-right: 0px !important;\n  }\n"])), css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), typographyByName('caption1')), COLORS.black, COLORS.gray7, COLORS.gray2, css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), typographyByName('subtitle3')), COLORS.gray7, COLORS.black, COLORS.black);
export var sumColumnWidth = function (columns) {
    return Lodash.sum(columns.map(function (column) {
        return isNumber(column.width) ? column.width : undefined || DEFAULT_COLUMN_WIDTH;
    }));
};
export var getMobileTableHeightWithCard = function (height, isPC, hasTab, hasPager) {
    var PAGER_HEIGHT = hasPager ? 50 : 0;
    var TAB_HEIGHT = hasTab ? 75 : 0;
    return isPC ? height - PAGER_HEIGHT - 350 : height - PAGER_HEIGHT - HEADER_WITH_SUBHEADER - 80 - TAB_HEIGHT;
};
export var XScrollableTable = function (props) {
    var _a = useMeasure(), wrapperRef = _a[0], width = _a[1].width;
    return (React.createElement(XScrollableTableWrapper, { ref: wrapperRef },
        React.createElement(TableComponent, __assign({}, props, { scroll: __assign({ x: width }, (props.scroll || {})) }))));
};
var XScrollableTableWrapper = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
